/**
 * Freezes given object.
 * If strict mode is active, exception when editing the object will be thrown.
 *
 * @param obj obj to freeze
 */
export const deepFreeze = <T extends Record<string, unknown>>(obj: T): Readonly<T> => {
    Object.keys(obj).forEach((key) => {
        const value = obj[key];
        if (!value || typeof value !== 'object') {
            return;
        }
        deepFreeze(value as Record<string, unknown>);
    });

    return Object.freeze(obj);
};
